export class DefaultEnvironment {
    dev?= false
    production?= false
    mode: 'dev' | 'test' | 'prod'
    apiUrl: string
    socketUrl: string

    dataDefaultCacheTime?= 60 * 60 * 1000

    timeCard?= {
        maxOvertimePercent: 2
    }

    trelloPunchListId?= '5d1a6ed72346d86fa682c7fa'
    trelloPunchCheckListName?= 'Punch List Items'
    trelloProdCheckListName?= 'Production'
    defaultJobsListLoadingInterval?= 3 * 60 * 1000
    googleMapsApiKey?= 'AIzaSyAIhewi58nz6nqc6VHich4aQUZatL7lmMg'
    systemState: 'Seattle' | 'California'
    systemSeattleUrl: string;
    systemCaliforniaUrl: string;
  systemCartTvUrl: string;

    // from desktop
    defaultEventsLoadingInterval?= 3 * 60 * 1000
    defaultEventShowHintDelay?= 600
    defaultEventHideHintDelay?= 300
    defaultNotificationsUpdateDelay?= 60 * 1000
    bottomOfSet?= 30
    errorMesage?= 'Something went wrong'
};
